<article class="container">
  <section class="full-width d-flex flex-column align-items-center">
    <h2>{{ 'SEARCH.title' | translate }}</h2>
    <app-search-bar class="col-xs-12 col-sm-10 col-md-8 col-lg-6"></app-search-bar>
  </section>
</article>
